import { render, staticRenderFns } from "./DeviceSelector.vue?vue&type=template&id=57ac127b&scoped=true"
import script from "./DeviceSelector.vue?vue&type=script&lang=js"
export * from "./DeviceSelector.vue?vue&type=script&lang=js"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./DeviceSelector.vue?vue&type=style&index=0&id=57ac127b&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "57ac127b",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ac127b')) {
      api.createRecord('57ac127b', component.options)
    } else {
      api.reload('57ac127b', component.options)
    }
    module.hot.accept("./DeviceSelector.vue?vue&type=template&id=57ac127b&scoped=true", function () {
      api.rerender('57ac127b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoCall/DeviceSelector.vue"
export default component.exports